export const JWT_TOKEN_STORAGE_KEY = 'mediego_jwt';

export function tokenGetter() {
  return localStorage.getItem(JWT_TOKEN_STORAGE_KEY);
}

export const JWT_MODULE_CONFIG = {
  config: {
    // Contrairement à ce qu'indique l'IDE, tokenGetter est bien utilisé (par la lib @auth0/angular-jwt) !
    tokenGetter,
    allowedDomains: [
      '127.0.0.1',
      '127.0.0.1:9000',
      '127.0.0.1:9001',
      '127.0.0.1:9002',
      '127.0.0.1:9003',
      'localhost',
      'localhost:9000',
      'localhost:9001',
      'localhost:9002',
      'localhost:9003',
      'mediego.pro',
      'mediego.com',
      'api.mediego.com',
      'api-qual.mediego.com'
    ],
    disallowedRoutes: [
      RegExp('.*\/api\/login'),
      RegExp('.*\/api\/signup'),
      RegExp('.*\/api\/accept-invite')
    ]
  }
};

export interface MediegoJwt {
  email: string;
  superAdmin: boolean;
}
